module.exports = __webpack_public_path__ + "img/0Q3A2940_L_Wood.a9cbd0c4.jpg";